import axios from "../../../axios"
import { getCurrentTenant } from '@/utils'

export default {
  fetch() {
    axios.defaults.baseURL = process.env.VUE_APP_API_BASE_URL + getCurrentTenant() + '/graphql'
    
    return axios.post('', {
      query: `
        query {
          messageTemplates {
            id,
            identifier,
            value
          }
        }
      `
    })
  },
  update(data) {
    axios.defaults.baseURL = process.env.VUE_APP_API_BASE_URL + getCurrentTenant() + '/graphql'
    
    return axios.post('', {
      query: `
        mutation {
          updateMessageTemplate(
            id: ${data.id},
            identifier: """${(data.identifier)}""",
            value: """${(data.value)}"""
          ) {
            id,
            identifier,
            value
          }
        }
      `
    })
  },
  delete(id) {
    axios.defaults.baseURL = process.env.VUE_APP_API_BASE_URL + getCurrentTenant() + '/graphql'
    
    return axios.post('', {
      query: `
        mutation {
          deleteMessageTemplate(
            id: ${id},
          )
        }
      `
    })
  },
  create(data) {
    axios.defaults.baseURL = process.env.VUE_APP_API_BASE_URL + getCurrentTenant() + '/graphql'
    
    return axios.post('', {
      query: `
        mutation {
          createMessageTemplate(
            identifier: """${(data.identifier)}""",
            value: """${(data.value)}"""
          ) {
            id,
            identifier,
            value
          }
        }
      `
    })
  }
}
